import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { EVSApi } from "../api/EVSApi";
import Paginacion from "../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { FiltrosEVS } from "./FiltrosEVS";
import { TableEVS } from "./TableEVS";
import { useDebounce } from "../../../../../Utils/Hooks/useDebounce";
import { getErrorFromResponse } from "../../../../../../../utility/utils";

export const Listado = ({ storageKey }) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const searchDefault = filtros.search || "";

    const { control, watch } = useForm({
        defaultValues: {
            search: searchDefault,
        },
    });

    const [registrosEVS, setRegistrosEVS] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);

    const { getRegistrosEVS, deleteRegistroEVS, cargando } = EVSApi();

    const GetRegistrosEVS = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            const response = await getRegistrosEVS(params);
            setRegistrosEVS(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las registrosEVS",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setRegistrosEVS([]);
            setCantidadResultados(0);
        }
    };

    const EliminarRegistroEVS = async (id) => {
        try {
            await deleteRegistroEVS(id);
            NotificationManager.success(
                "EVS eliminado correctamente",
                "Éxito",
                3000,
            );
            GetRegistrosEVS();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar EVS",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        GetRegistrosEVS();
    }, [debouncedSearch, paginaSeleccionada]);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                search: debouncedSearch,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [debouncedSearch, paginaSeleccionada]);

    return (
        <div className="listado-evs__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <div className="listado-evs__table-header">
                        <FiltrosEVS
                            control={control}
                            onRefresh={() => {
                                GetRegistrosEVS();
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                            searchPlaceholder={"EVS, cliente, producto..."}
                        />
                        <Link to={`/evs/crear-evs`}>
                            <button className="btn btn-primary">
                                Crear EVS
                            </button>
                        </Link>
                    </div>

                    <TableEVS
                        registrosEVS={registrosEVS}
                        EliminarRegistroEVS={EliminarRegistroEVS}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
